export class NewAccountEntryResult {
  isOk: boolean;
  isMailSendFailed: boolean;
  isAlreadyRegistered: boolean;
}
